import styled from "styled-components";

export const Container = styled.div`
  width: 208px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
`

export const CardItem = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  cursor: pointer;

  .cardItemIcon {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  .cardItemText {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 6px;
  }

  &:hover {
    background-color: ${({theme}) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }
`

export const Hr = styled.hr`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  margin: 1.5px 0;
`

export const MoreActionsMenuStatusChange = styled.div`
  width: 119px;
  padding: 4px 0;
  background: ${({ theme }) => theme.colors.surface.surface};
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  cursor: auto;

  .moreActionsOptions {
    padding: 10px 0 10px 15px;
    font-weight: 400;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }
  }
`
